<template>
  <toast class="position-absolute start-50 border-info" ref="toast">
    <toast-body :message="message" />
  </toast>
</template>

<script>
import Toast from '@/views/atoms/Toast'
import ToastBody from '@/views/atoms/ToastBody'

export default {
  name: "InfoToast",
  components: {
    Toast,
    ToastBody,
  },
  data() {
    return {
      message: '',
    }
  },
  methods: {
    show(message) {
      this.message = message;
      this.$refs.toast.show();
    },
  },
}
</script>

<style scoped>
.toast {
  top: 30px;
  width: 600px;
  animation-name: slide-in;
  animation-duration: 5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translate(-50%, -30px);
  }
  10% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  90% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -30px);
  }
}
</style>
